import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=49d46389&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=ts"
export * from "./ContentFooter.vue?vue&type=script&lang=ts"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=49d46389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d46389",
  null
  
)

export default component.exports